<template>
  <div class="LojaRepres">
    <LojaRepres />
  </div>
</template>

<script>
import LojaRepres from "./components/LojaRepresentantes";

export default {
  name: "LojaRepresentante",
  components: {
    LojaRepres
  }
};
</script>

<style scoped>
</style>
